import axios from "axios";

export default async function filterValidatedDocuments(projectName, formName, data) {
    const res = await axios.post(`/project/${projectName}/${formName}/research-document-validated`, data, { responseType: "blob" });
    return res
}